import { reCAPTCHA } from '@/utils/API';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return { recaptcha: reCAPTCHA ? executeRecaptcha : true };
};
